module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.error[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Номер дома")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "number",
      "placeholder": "Введите номер"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error[0]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2381333a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/building/fields/BuildingNumber.vue
// module id = 600
// module chunks = 0